import { noSignalIndicatorEl, noSignalIndicatorIconEl } from "./elements";
import { getLogger } from "./logging";
import { Network } from "./plugins";
import store from "./store";

const log = getLogger("🌐 Network");

Network.addListener("networkStatusChange", ({ connected }) => {
  store.internetConnected = connected;
  handleConnectivityState();
});

addEventListener(
  "requestsTimingOutChange",
  ({ detail: { requestsTimingOut } }) => {
    store.requestsTimingOut = requestsTimingOut;
    handleConnectivityState();
  }
);

export const setCurrentNetworkStatus = async () => {
  const { connected } = await Network.getStatus();
  log.debug(`Connected: ${connected}`);
  store.internetConnected = connected;
  handleConnectivityState();
};

function handleConnectivityState() {
  const connectivityIssue = store.requestsTimingOut || !store.internetConnected;
  noSignalIndicatorIconEl.innerHTML = store.requestsTimingOut
    ? "signal_wifi_statusbar_not_connected"
    : "wifi_off";
  noSignalIndicatorEl.style.display = connectivityIssue ? "initial" : null;
  noSignalIndicatorEl.style.backgroundColor = store.requestsTimingOut
    ? "#f7c965"
    : null;
}
